export enum SearchTemplateDeleteTypeEnum {
  RECENT_SEARCH = "RECENT_SEARCH",
  TEMPLATES = "TEMPLATES",
}
